'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _input = require('../components/input');
var _input2 = _interopRequireDefault(_input);
var _propTypes = require('prop-types');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
Postcode.propTypes = {
  name: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),
  vehicleKept: _propTypes.bool
};
Postcode.defaultProps = {
  name: function name(vehicleKept) {
    return vehicleKept ? 'postcodeKeptOvernight' : 'postcode';
  },
  label: function label(vehicleKept) {
    return vehicleKept ? 'Postcode where the car is kept' : 'Please enter your postcode';
  },
  vehicleKept: false
};
function Postcode(_ref) {
  var vehicleKept = _ref.vehicleKept,
    name = _ref.name,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, ['vehicleKept', 'name', 'label']);
  return _react2.default.createElement(_input2.default, Object.assign({
    name: typeof name === 'string' ? name : name(vehicleKept),
    label: typeof label === 'string' ? label : label(vehicleKept),
    format: ['uppercase', 'alpha-int'],
    maxLength: '8'
  }, rest));
}
exports.default = Postcode;